import TimeRangeSlider from './TimeRangeSlider';

// biome-ignore lint/performance/noBarrelFile: This barrel file is used to consolidate and re-export constants, types, and utility functions for the TimeRangeSlider component, improving import organization and developer experience.
export { SLIDER_CONFIG, TIME_CONSTANTS, TIME_MARKS_CONFIG, TIME_RANGE_LABEL } from './constants';

export type { TimeMark, TimeRange, TimeRangeSliderProps } from './types';

export {
  calculateTimeRange,
  formatTimeRange,
  generateTimeMarks,
  minutesToTime,
  timeToMinutes,
} from './utils';

export default TimeRangeSlider;
